module.exports = __webpack_public_path__ + "130390e41801280bfdd0403722c4f36a.svg";